export default function makeMaterialStyle(/*theme*/) {
    return {}
}
